var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28314 14.1615C6.19748 14.1212 8.77166 12.5477 10.2148 11.0549C13.725 7.42371 14.6611 0.121039 14.7001 0C14.7001 0 15.5191 7.54475 19.3024 11.0549C22.7736 14.2826 26.7909 14.6457 28 14.7264C27.727 14.7264 27.3759 14.7264 26.9079 14.7264C26.2449 14.7264 21.7596 15.0088 18.8344 17.1472C14.427 20.4152 14.6611 27.4355 14.7001 28.0003C14.6611 27.0723 14.232 19.5276 9.86374 16.8244C8.42064 15.9368 5.53444 14.9281 2.76525 14.4036C2.1412 14.2826 1.59516 14.2019 1.24414 14.1615H1.28314Z",
    fill: "#0C1331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390027 13.5321C4.95334 13.4936 7.52752 11.99 8.97062 10.5635C12.4809 7.09377 13.4169 0.115659 13.4559 0C13.4559 0 14.275 7.20943 18.0582 10.5635C21.5295 13.6478 25.5468 13.9948 26.7558 14.0719C26.4828 14.0719 26.1318 14.0719 25.6638 14.0719C25.0007 14.0719 20.5154 14.3417 17.5902 16.3851C13.1829 19.5079 13.4169 26.2161 13.4559 26.7558C13.4169 25.8691 12.9879 18.6597 8.6196 16.0766C7.1765 15.2285 4.2903 14.2646 1.52111 13.7635C0.897062 13.6478 0.351024 13.5707 0 13.5321H0.0390027Z",
    fill: "#E4E424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.55b83d5893fc55b878014b2169ee7bf1.svg";
export { ForwardRef as ReactComponent };